import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import API, { handleApiError } from '../../../lib/api';
import AdminEditUserView from './View';
import UserNotFound from '../AdminUserNotFound';

import Loading from '../../common/Loading';

function AdminEditUserContainer({ id }) {
  const userId = id;
  // Data state to store the users data. Its initial value is an empty array
  const [data, setData] = useState([]);
  const [displayError, setDisplayError] = React.useState();
  const [isLoading, setIsLoading] = useState(true);

  const fetchData = async () => {
    await API.get(`users/${userId}`)
      .then((res) => {
        setData(res.data);
      })
      .catch((error) => {
        handleApiError({ error, setDisplayError });
      })
      .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    if (!userId) {
      return;
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId]);

  if (isLoading) return <Loading />;
  return data && data._id ? (
    <AdminEditUserView
      data={data}
      refetchData={fetchData}
      onUpdateUser={(user) => setData(user)}
    />
  ) : (
    <UserNotFound id={userId} displayError={displayError} />
  );
}

AdminEditUserContainer.propTypes = {
  id: PropTypes.string.isRequired,
};

export default AdminEditUserContainer;
